// extracted by mini-css-extract-plugin
export var adjacentSlide = "_s4-9";
export var arrowButtonContainer = "_s4-5";
export var arrowButtonIcon = "_s4-6";
export var carouselArrowButton = "_s4-2";
export var carouselElementContainer = "_s4-1";
export var currentSlide = "_s4-8";
export var left = "_s4-3";
export var otherSlide = "_s4-a";
export var productCarouselContainer = "_s4-0";
export var right = "_s4-4";
export var sliderOverflow = "_s4-7";